jQuery(function ($) {
    // Scroll Out
    ScrollOut({
        scrollingElement: '#page',
        threshold: 1,
    });
    ScrollOut();

    //Baguette Box
    baguetteBox.run('.galerie');
    baguetteBox.run('.masonry');

    // On fait remonter en haut de la page avant le reload de la page via le navigateur
    // $(window).on('beforeunload', function () {
    //     $(window).scrollTop(0);
    // });


    // GESTION DES NAVBAR MOBILE / DESKTOP
    var wrapperNavbar = $('#wrapper-navbar');
    var minWidth1200 = window.matchMedia("(min-width: 1200px)");

    $(window).scroll(function () {
        if (minWidth1200.matches) {
            if ($(window).scrollTop() === 0) {
                wrapperNavbar.removeClass('bg-black-light');
            }
            if ($(window).scrollTop() > 0) {
                wrapperNavbar.addClass('bg-black-light');
                wrapperNavbar.css('margin-top', 0);
            }
        }
    });

    // DEBUT OWN CAROUSEL
    $(".owl-carousel.owl-carousel-galerie").owlCarousel({
        lazyLoad: true,
        loop: true,
        nav: false,
        dots: false,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
            320: {
                items: 1,
                margin: 2,
                stagePadding: 50,
            },
            425: {
                items: 2,
                margin: 2,
                stagePadding: 50,
            },
            768: {
                items: 4,
                margin: 2,
                stagePadding: 50,
            },
            1200: {
                margin: 15,
                items: 5,
                stagePadding: 150,
            },
            1600: {
                margin: 15,
                items: 6,
                stagePadding: 150,
            }
        }
    });

    $(".owl-carousel.owl-carousel-nos-bieres").owlCarousel({
        items: 2,
        lazyLoad: true,
        loop: true,
        nav: true,
        navText: ["", ""],
        dots: false,
        autoplay: true,
        autoplayTimeout: 2000,
        autoplayHoverPause: true,
        responsive: {
            320: {
                margin: 1,
                items: 1,
                stagePadding: 20,
            },
            768: {
                margin: 1,
                items: 2,
                stagePadding: 50,
            },

            1600: {
                margin: 1,
                items: 3,
                stagePadding: 150,
            }
        }
    });
    // FIN OWN CAROUSEL

    // DEBUT Galerie Masonry
    $(function () {
        var itemGalerie = $(".galerie-masonry__elements__item");
        $(itemGalerie).slice(0, 8).show();
        $("#loadMore").on('click', function (e) {
            e.preventDefault();
            $(".galerie-masonry__elements__item:hidden").slice(0, 4).slideDown();
            if ($(".galerie-masonry__elements__item:hidden").length == 0) {
                $(".loadMore").hide("slow", function () {
                });
            }
            $('html,body').animate({
                scrollTop: $('#loadMore').offset().top - 200
            }, 1000);
        });
    });
    // FIN Galerie Masonry

    // DEBUT BOUTON SCROLL TOP
    $(window).scroll(function () {
        if ($(window).scrollTop() > 300) {
            $('#bouton-scroll-top').addClass('show');
        } else {
            $('#bouton-scroll-top').removeClass('show');
        }
    });

    $('#bouton-scroll-top').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({scrollTop: 0}, '300');
    });
    // FIN BOUTON SCROLL TOP

    // DEBUT NAVBAR OPEN HOVER
    var $dropdown = $(".dropdown");
    var $dropdownToggle = $(".dropdown-toggle");
    var $dropdownMenu = $(".dropdown-menu");
    var showClass = "show";

    $(window).on("load resize", function () {
        if (this.matchMedia("(min-width: 1200px)").matches) {
            $dropdown.hover(
                function () {
                    var $this = $(this);
                    $this.addClass(showClass);
                    $this.find($dropdownToggle).attr("aria-expanded", "true");
                    $this.find($dropdownMenu).addClass(showClass);
                },
                function () {
                    var $this = $(this);
                    $this.removeClass(showClass);
                    $this.find($dropdownToggle).attr("aria-expanded", "false");
                    $this.find($dropdownMenu).removeClass(showClass);
                }
            );
        } else {
            $dropdown.off("mouseenter mouseleave");
        }
    });
    // FIN NAVBAR OPEN HOVER


    // DEBUT ADULT CONTENT
    $('#adult-content--bouton-enter').click(function (e) {
        e.preventDefault();
        $('#adult-content').css('display', 'none');
        sessionStorage.setItem("accept-adult-content-brasserie-de-bretagne", "yes");
    });

    var acceptAdultContent = sessionStorage.getItem("accept-adult-content-brasserie-de-bretagne");
    if (acceptAdultContent !== 'yes') {
        $('#adult-content').css('display', 'flex');
    }
    // FIN ADULT CONTENT


//essai gallerie img
    //Modification image principale fiche produit
    var photoPrincipale = $('.bloc-produits-archive__parent__photo__lien img');
    var lienPhotoPrincipale = $('.bloc-produits-archive__parent__photo__lien');
    var photoMiniature = $('.bloc_miniature_produit_single .woocommerce-product-gallery__image a');


    //Changement photo au clic sur une miniature. Changement du src du zoom au hover
    $(photoMiniature).click(function (e) {

        //Déclaration variables
        var lienPhotoMiniature = this;
        var photoPrincipaleZoom = $('.zoomImg');

        // 1- Désactive l'action du lien
        e.preventDefault();

        // 2- Change tous les src de l'image principale
        $(lienPhotoPrincipale).attr('href', lienPhotoMiniature);
        $(photoPrincipale).attr('src', lienPhotoMiniature);
        $(photoPrincipale).attr('title', lienPhotoMiniature);
        $(photoPrincipale).attr('data-src', lienPhotoMiniature);
        $(photoPrincipale).attr('data-large_image', lienPhotoMiniature);
        $(photoPrincipale).attr('data-large_image_width', lienPhotoMiniature);
        $(photoPrincipale).attr('srcset', lienPhotoMiniature);
        $(photoPrincipale).attr('data-height', lienPhotoMiniature);
        $(photoPrincipale).attr('data-srcset', lienPhotoMiniature);

        // 3 - Change le zoom au hover de l'image principale
        $(photoPrincipaleZoom).attr('src', lienPhotoMiniature);
    });



    //********************************************************************* */
    //***** Affichage des pastilles rondes pour les attributs fiche produit */
    //********************************************************************* */

    // Template des jauges single product
    var templateJauge1 = '' +
        '<td class="woocommerce-product-attributes-item__value">\n' +
        '<div class="d-flex parent-jauge">\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '</div>\n' +
        '</td>\')'

    var templateJauge2 = '' +
        '<td class="woocommerce-product-attributes-item__value">\n' +
        '<div class="d-flex parent-jauge">\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '</div>\n' +
        '</td>\')'

    var templateJauge3 = '' +
        '<td class="woocommerce-product-attributes-item__value">\n' +
        '<div class="d-flex parent-jauge">\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '</div>\n' +
        '</td>\')'

    var templateJauge4 = '' +
        '<td class="woocommerce-product-attributes-item__value">\n' +
        '<div class="d-flex parent-jauge">\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-vide"></div>\n' +
        '</div>\n' +
        '</td>\')'

    var templateJauge5 = '' +
        '<td class="woocommerce-product-attributes-item__value">\n' +
        '<div class="d-flex parent-jauge">\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '<div class="jauge-pleine"></div>\n' +
        '</div>\n' +
        '</td>\')'

    /////////////////////////////////////////////////////////
    //Prise en charge des attributs avec caractères spéciaux
    /////////////////////////////////////////////////////////

    //Création des éléments
    var fruite = document.createElement("p");
    var floralite = document.createElement("p");
    var epices = document.createElement("p");

    // Création du texte correspondant
    var fruite_content = document.createTextNode("Fruité");
    var floralite_content = document.createTextNode("Floralité");
    var epices_content = document.createTextNode("Épices");

    // Applique ce contenu aux nouveaux éléments
    fruite.appendChild(fruite_content);
    floralite.appendChild(floralite_content);
    epices.appendChild(epices_content);

    //Changement du texte dans le DOM
    $(".woocommerce-product-attributes-item--attribute_fruite .woocommerce-product-attributes-item__label").html(fruite);
    $(".woocommerce-product-attributes-item--attribute_floralite .woocommerce-product-attributes-item__label").html(floralite);
    $(".woocommerce-product-attributes-item--attribute_epices .woocommerce-product-attributes-item__label").html(epices);

    //////////////////////////////////////////////////////////////
    // FIN Prise en charge des attributs avec caractères spéciaux
    /////////////////////////////////////////////////////////////

    //Fonction pour afficher les pastilles
    function affichageRonds (attributElement){

        var valeurElement = $(attributElement).text();

        if (valeurElement.trim() === '1') {
            $(attributElement).replaceWith(templateJauge1);
        }
        if (valeurElement.trim() === '2') {
            $(attributElement).replaceWith(templateJauge2);
        }
        if (valeurElement.trim() === '3') {
            $(attributElement).replaceWith(templateJauge3);
        }
        if (valeurElement.trim() === '4') {
            $(attributElement).replaceWith(templateJauge4);
        }
        if (valeurElement.trim() === '5') {
            $(attributElement).replaceWith(templateJauge5);
        }
    }

    //Récupération de la classe des attributs
    var elementAmertume = $('.woocommerce-product-attributes-item--attribute_amertume .woocommerce-product-attributes-item__value');
    var elementFruite = $('.woocommerce-product-attributes-item--attribute_fruite .woocommerce-product-attributes-item__value');
    var elementFloralite = $('.woocommerce-product-attributes-item--attribute_floralite .woocommerce-product-attributes-item__value');
    var elementEpices = $('.woocommerce-product-attributes-item--attribute_epices .woocommerce-product-attributes-item__value');


    //Affichage des ronds
    affichageRonds(elementAmertume);
    affichageRonds(elementFruite);
    affichageRonds(elementFloralite);
    affichageRonds(elementEpices);



    // Appel de la gestion de cookies RGPD
    jQuery(".cookies").on("click", function(e){
        e.preventDefault();
        if( tarteaucitron ) {
            tarteaucitron.userInterface.openPanel()
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    menuDevelop();
});

function menuDevelop () {

    //Pour fermer les sous-menus ouverts
    const body = document.querySelector("body");
    body.addEventListener("click", function(event) {
        const isDropdownItem = event.target.classList.contains("dropdown-item") || event.target.closest(".dropdown-item");
        if (!isDropdownItem) {
            const shownDropdowns = document.querySelectorAll(".dropdown-menu .show, .dropdown-submenu .show");
            shownDropdowns.forEach(dropdown => dropdown.classList.remove("show"));
        }
    });

    //Pour gérer les sous-menus
    const dropdownItems = document.querySelectorAll(".menu-item-has-children > .dropdown-item");
    dropdownItems.forEach(item => {
        item.addEventListener("click", function(event) {
            event.preventDefault();
            event.stopPropagation();

            const isDropdownShown = this.nextElementSibling.classList.contains("show");
            const parentDropdownMenu = this.closest(".dropdown-menu");

            if (!isDropdownShown) {
                const shownDropdown = parentDropdownMenu.querySelector(".show");
                if (shownDropdown) {
                    const childDropdowns = shownDropdown.querySelectorAll(".dropdown-menu .show");
                    childDropdowns.forEach(child => child.classList.remove("show"));
                    shownDropdown.classList.remove("show");
                }
            }

            this.nextElementSibling.classList.toggle("show");

            const parentDropdown = this.closest("li.nav-item.dropdown.show");
            if (parentDropdown) {
                parentDropdown.addEventListener("hidden.bs.dropdown", function(event) {
                    const shownDropdowns = document.querySelectorAll(".dropdown-menu .show, .dropdown-submenu .show");
                    shownDropdowns.forEach(dropdown => dropdown.classList.remove("show"));
                });
            }
        });
    });

    // Ajouter la fonction pour fermer #navbarNavDropdown
    function closeNavbarNavDropdown(event) {
        const navbarNavDropdown = document.querySelector("#navbarNavDropdown");
        const isClickInsideNavbar = navbarNavDropdown.contains(event.target);

        if (!isClickInsideNavbar) {
            // Fermer le #navbarNavDropdown
            navbarNavDropdown.classList.remove("show");
        }
    }

    // Ajouter un écouteur d'événements au document
    document.addEventListener("click", closeNavbarNavDropdown);
}
